import { FormattedMessage } from 'react-intl';

import { Button } from '@xing-com/button';
import { GridContainer } from '@xing-com/grid';

import { Styled } from './generic-page-error.styles';

export type GenericPageErrorType = {
  refetch: () => void;
};

export const GenericPageError: React.FC<GenericPageErrorType> = ({
  refetch,
}) => (
  <GridContainer variant="FullSize">
    <Styled.GridItem span={8} start={3} spanMedium={6} startMedium={4}>
      <Styled.IllustrationErrorGenericSmall />
      <Styled.Headline size="xxlarge">
        <FormattedMessage id="EP_ERROR_HEADER" />
      </Styled.Headline>
      <Styled.BodyCopy>
        <FormattedMessage id="EP_ERROR_BODY" />
      </Styled.BodyCopy>
      <Button onClick={() => refetch()} variant="secondary">
        <FormattedMessage id="MOVEON_GENERIC_ERROR_CTA" />
      </Button>
    </Styled.GridItem>
  </GridContainer>
);
